var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 43.22,
    viewBox: "0 0 100 43.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(811.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(-811.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M-803.019,0h-8.374V23.722h20.759V17.576h-12.384Z",
    transform: "translate(811.393)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M-636.363,14.772h10.04V9.094h-10.04V6.146h12.233V0h-20.607V23.722H-623.7V17.576h-12.664Z",
    transform: "translate(668.747)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M-452.036,8.806l.144,4.888h-.072L-460.982,0h-9.057V23.722h7.26V14.916l-.144-4.888h.072l9.018,13.694h9.057V0h-7.26Z",
    transform: "translate(519.217)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M-263.308,0V23.722h7.32V17.54h6.4v6.182h7.32V0Zm13.718,11.861h-6.4V6.146h6.4Z",
    transform: "translate(342.268)",
    fill: "#303030"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(-811.4 30.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M-644.6,231.185h2.419v6.08h1.146v-6.08h2.419V230.2H-644.6Z",
    transform: "translate(668.626 -227.26)",
    fill: "#16becf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M-577.744,233.588a2.021,2.021,0,0,0,.391-1.268,1.932,1.932,0,0,0-.664-1.557,2.711,2.711,0,0,0-1.809-.562h-2.88v7.065h1.135v-2.826h1.52l1.8,2.826h1.316l-1.916-2.954A2.108,2.108,0,0,0-577.744,233.588Zm-2.178-.1h-1.648v-2.312h1.648a1.6,1.6,0,0,1,1.038.284,1.068,1.068,0,0,1,.343.872,1.067,1.067,0,0,1-.343.872A1.6,1.6,0,0,1-579.922,233.486Z",
    transform: "translate(615.652 -227.26)",
    fill: "#16becf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M-525.058,230.2l-2.665,7.065h1.177l.674-1.852h2.976l.664,1.852h1.21l-2.665-7.065Zm-.482,4.282.835-2.291.3-1h.032l.321,1.017.813,2.269Z",
    transform: "translate(568.591 -227.26)",
    fill: "#16becf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M-456.938,234.76l.043,1.2h-.011l-.7-1.317-2.719-4.442h-1.349v7.065h1.049v-4.56l-.043-1.2h.011l.685,1.306,2.73,4.453h1.359V230.2h-1.06Z",
    transform: "translate(512.054 -227.26)",
    fill: "#16becf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M-395.447,233.048a6.309,6.309,0,0,0-1.515-.434,4.252,4.252,0,0,1-1.413-.434.77.77,0,0,1-.4-.68.9.9,0,0,1,.407-.755,1.928,1.928,0,0,1,1.145-.294,2.193,2.193,0,0,1,1.2.289,2.143,2.143,0,0,1,.749.931l.867-.781a3.023,3.023,0,0,0-1.161-1.081,3.62,3.62,0,0,0-1.664-.353,3.456,3.456,0,0,0-1.461.289,2.264,2.264,0,0,0-.958.781,1.91,1.91,0,0,0-.332,1.092,1.7,1.7,0,0,0,.262.963,1.956,1.956,0,0,0,.84.664,6.713,6.713,0,0,0,1.552.45,4.462,4.462,0,0,1,1.365.418.706.706,0,0,1,.391.621.825.825,0,0,1-.434.744,2.3,2.3,0,0,1-1.194.262,2.739,2.739,0,0,1-1.343-.3,2.243,2.243,0,0,1-.883-.942l-.8.8a3.29,3.29,0,0,0,3.04,1.434,3.99,3.99,0,0,0,1.472-.251,2.22,2.22,0,0,0,.99-.723,1.769,1.769,0,0,0,.353-1.092,1.727,1.727,0,0,0-.257-.969A1.914,1.914,0,0,0-395.447,233.048Z",
    transform: "translate(459.463 -226.624)",
    fill: "#16becf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M-333.056,230.789a2.651,2.651,0,0,0-1.814-.589h-2.719v7.065h1.145V234.6h1.573a2.665,2.665,0,0,0,1.814-.583,2.025,2.025,0,0,0,.669-1.611A2.042,2.042,0,0,0-333.056,230.789Zm-.883,2.532a1.708,1.708,0,0,1-1.113.305h-1.392v-2.451h1.392q1.477,0,1.477,1.231A1.127,1.127,0,0,1-333.939,233.32Z",
    transform: "translate(405.849 -227.26)",
    fill: "#16becf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M-277.806,229.9a3.461,3.461,0,0,0-1.772-.439,3.431,3.431,0,0,0-1.766.439,2.922,2.922,0,0,0-1.156,1.263,4.329,4.329,0,0,0-.407,1.938,4.328,4.328,0,0,0,.407,1.937,2.92,2.92,0,0,0,1.156,1.263,3.43,3.43,0,0,0,1.766.439,3.46,3.46,0,0,0,1.772-.439,2.914,2.914,0,0,0,1.161-1.263,4.333,4.333,0,0,0,.407-1.937,4.333,4.333,0,0,0-.407-1.938A2.915,2.915,0,0,0-277.806,229.9Zm-.2,5.149a1.918,1.918,0,0,1-1.573.7,1.907,1.907,0,0,1-1.563-.7,3,3,0,0,1-.567-1.948,3,3,0,0,1,.567-1.948,1.907,1.907,0,0,1,1.563-.7,1.919,1.919,0,0,1,1.573.7,3,3,0,0,1,.568,1.948A3,3,0,0,1-278,235.045Z",
    transform: "translate(359.045 -226.624)",
    fill: "#16becf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M-208.993,233.588a2.02,2.02,0,0,0,.391-1.268,1.932,1.932,0,0,0-.664-1.557,2.711,2.711,0,0,0-1.809-.562h-2.879v7.065h1.135v-2.826h1.52l1.8,2.826h1.317l-1.916-2.954A2.108,2.108,0,0,0-208.993,233.588Zm-2.178-.1h-1.648v-2.312h1.648a1.6,1.6,0,0,1,1.038.284,1.068,1.068,0,0,1,.342.872,1.067,1.067,0,0,1-.342.872A1.6,1.6,0,0,1-211.171,233.486Z",
    transform: "translate(300.026 -227.26)",
    fill: "#16becf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M-159.419,230.2v.985H-157v6.08h1.146v-6.08h2.419V230.2Z",
    transform: "translate(253.347 -227.26)",
    fill: "#16becf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M-804.968,209.789H-811.4l4.457,6.5-4.457,6.5h6.432l4.457-6.5Z",
    transform: "translate(811.4 -209.789)",
    fill: "#16becf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M-742.888,209.789l4.457,6.5-4.457,6.5h6.432l4.457-6.5-4.457-6.5Z",
    transform: "translate(752.759 -209.789)",
    fill: "#16becf"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.378866a24e7386e5a52c819f807dbd82.svg";
export { ForwardRef as ReactComponent };